import { IntegrationErrorStatus } from '../../@types';

export type StatusFilterValue = IntegrationErrorStatus | 'todos';
export type PeriodoModo = '10dias' | '15dias' | 'customizado' | null;

export interface PeriodoOption {
  label: string;
  value: Exclude<PeriodoModo, null>;
}

export interface StatusOption {
  label: string;
  value: StatusFilterValue;
}

export const PERIODO_OPTIONS: PeriodoOption[] = [
  { label: 'Últimos 10 dias', value: '10dias' },
  { label: 'Últimos 15 dias', value: '15dias' },
  { label: 'Período customizado', value: 'customizado' },
];

export const STATUS_OPTIONS: StatusOption[] = [
  { label: 'Todos', value: 'todos' },
  { label: 'Confirmado', value: 'confirmado' },
  { label: 'Erro', value: 'erro' },
  { label: 'Pendente', value: 'pendente' },
  { label: 'Processando', value: 'processando' },
];
